<!-- activity-log.component.html -->
<div class="activity-log">
  <div class="activity-log-container">
    @if (logs().length > 0) {
      <div class="timeline">
        @for (log of logs(); track log.id) {
          <div class="timeline-item" (click)="openDetail(log)">
            <div class="timeline-icon" [ngClass]="getEventConfig(log.event_type).colorClass">
              <span class="material-icons">{{ getEventConfig(log.event_type).icon }}</span>
            </div>
            
            <div class="timeline-card">
              <div class="card-header">
                <span class="card-title">{{ getEventConfig(log.event_type).label }}</span>
                <span class="card-meta">
                  @if (log.created_by) {
                    <span class="created-by">by <span class="created-by-name">{{ getCreatedByName(log) }}</span></span>
                    <span class="meta-separator">·</span>
                  }
                  <span class="card-time">{{ log.created_at | customDate }}</span>
                </span>
              </div>
              
              @if (getEventSubtitle(log)) {
                <p class="card-subtitle">{{ getEventSubtitle(log) }}</p>
              }
            </div>
          </div>
        }
      </div>

      @if (showLoad()) {
        <div class="load-more-wrapper">
          <div class="load-more-btn" (click)="loadMore()" [class.loading]="loading()">
            @if (!loading()) {
              <span class="material-icons">expand_more</span>
              <span>Load more</span>
            } @else {
              <div class="loader"></div>
              <span>Loading...</span>
            }
          </div>
        </div>
      }
    } @else if (!loading()) {
      <div class="empty-state">
        <div class="empty-icon-wrapper">
          <span class="material-icons">history</span>
        </div>
        <h3>No Activity Yet</h3>
        <p>Activity logs will appear here as actions are performed on this lead.</p>
      </div>
    }
  </div>
</div>